import $ from 'jquery';

export default class UserChannelPostCard {
  init() {
    // User channel post channel toggle
    $(document).on('click', '.user-channel-post-card__channels-toggle-all button', event => {
      const self = $(event.currentTarget);
      const parent = self.parents('.user-channel-post-card__channels-toggle-all');

      const openState = parent.data('open');
      if (!openState) {
        self.find('span:first-child').text('Visa färre');
        self.find('span:last-child').css('transform', 'rotate(180deg)');
        parent.siblings('.expandable').removeClass('d-lg-none');
        parent.data('open', true);
      } else {
        self.find('span:first-child').text('Visa alla');
        self.find('span:last-child').css('transform', null);
        parent.siblings('.expandable').addClass('d-lg-none');
        parent.data('open', false);
      }
    });

    const cards = $('.user-channel-post-card');

    // Local storage read articles
    let curStorage = localStorage.getItem('visitedPostId');
    if (curStorage) {
      curStorage = curStorage.split(',');
    } else {
      curStorage = [];
    }

    cards.each((i, elm) => {
      const self = $(elm);
      const post_id = self.data('post-id');

      if (post_id && curStorage.includes(post_id.toString()) === false) {
        self.addClass('unread');
      }
    });

    $(window).on('scroll', () => {
      const scrollTop = $(window).scrollTop();

      cards.each((i, elm) => {
        const card = $(elm);
        const post_id = card.data('post-id');

        if (curStorage.includes(post_id.toString()) === false) {
          const card_offset = card.offset();
          const card_height = card.height();

          if (scrollTop > (card_offset.top + (card_height / 2))) {
            curStorage.push(post_id.toString());
            card.removeClass('unread');
            localStorage.setItem('visitedPostId', curStorage.toString());
          }
        }
      });
    });
  }
}
